import React, { Component } from 'react';

class TagComponent extends Component {
    render() {
        return (
            <div className={this.props.chosen ? "tag-element chosen" : this.props.chosenAlready ? "chosen-already tag-element" : "tag-element"} onClick={() => this.props.onClick()}>
              {this.props.tag}
            </div>
        );
    }
}

export default TagComponent;
